// extracted by mini-css-extract-plugin
export var clampContainers = "NextToJumpSkeleton-module--clampContainers--15a0a";
export var clampMore = "NextToJumpSkeleton-module--clampMore--f78cc";
export var clampStatus = "NextToJumpSkeleton-module--clampStatus--9d88e";
export var longTitle = "NextToJumpSkeleton-module--longTitle--1dc5c";
export var nextToJumpIcon = "NextToJumpSkeleton-module--nextToJumpIcon--4d63c";
export var raceNumberIcon = "NextToJumpSkeleton-module--raceNumberIcon--2be36";
export var row = "NextToJumpSkeleton-module--row--7976e";
export var runnerInfo = "NextToJumpSkeleton-module--runnerInfo--2f154";
export var runnerSubText = "NextToJumpSkeleton-module--runnerSubText--e4d95";
export var runnerTitle = "NextToJumpSkeleton-module--runnerTitle--7b857";
export var runnerTitleText = "NextToJumpSkeleton-module--runnerTitleText--26cfb";